import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { EchoService } from '../../_services/echo.service';

interface IncomingCall {
  id: string;
  caller: string;
  callee: string;
  direction: string;
  status: string;
  started_at: string;
  user?: string[];
  customerName?: string;
  orderId?: string;
  orderNumber?: string;
  orderData?: any;
  rootOrderData?: any;
}

@Component({
  selector: 'app-incoming-call',
  templateUrl: './incoming-call.component.html',
  styleUrls: ['./incoming-call.component.css']
})
export class IncomingCallComponent implements OnInit, OnDestroy {
  incomingCall: IncomingCall | null = null;
  visible = false;
  private echo: any;

  constructor(
    private echoService: EchoService,
    private router: Router
  ) {}

  ngOnInit() {
    this.echo = this.echoService.getEcho();
    
    if (this.echo) {
      this.echo.channel('sipgate-calls').listen('incoming.sipgate.call', (event: any) => {
        this.handleIncomingCall(event);
      });
    }
  }

  ngOnDestroy() {
    if (this.echo) {
      this.echo.leave('sipgate-calls');
    }
  }

  private handleIncomingCall(event: any) {
    if (event.type === 'incoming_call' && event.call) {
      this.incomingCall = event.call;
      this.visible = true;
      console.log('Eingehender Anruf erhalten:', event.call);
      console.log('Auftragsdaten:', event.call.orderData);
      console.log('Root-Auftragsdaten:', event.call.rootOrderData);
    }
  }

  answerCall() {
    if (this.incomingCall) {
      console.log('Anruf angenommen:', this.incomingCall.id);
      this.echoService.markCallHandled(this.incomingCall.id);
      this.stopHeaderPhoneRinging();
      this.visible = false;
      this.incomingCall = null;
    }
  }

  rejectCall() {
    if (this.incomingCall) {
      console.log('Anruf abgelehnt:', this.incomingCall.id);
      this.echoService.markCallHandled(this.incomingCall.id);
      this.stopHeaderPhoneRinging();
      this.visible = false;
      this.incomingCall = null;
    }
  }

  dismiss() {
    if (this.incomingCall) {
      console.log('Anruf-Benachrichtigung geschlossen:', this.incomingCall.id);
      this.echoService.markCallHandled(this.incomingCall.id);
      this.stopHeaderPhoneRinging();
      this.visible = false;
      this.incomingCall = null;
    }
  }

  openOrder() {
    if (this.incomingCall?.orderId) {
      console.log('Öffne Auftrag:', this.incomingCall.orderId);
      // Navigiere zur Auftragsseite
      this.router.navigate(['/content/order', this.incomingCall.orderId]);
      // Schließe die Benachrichtigung nach der Navigation
      this.dismiss();
    }
  }

  /**
   * Stoppt das Telefonklingeln im Header
   */
  private stopHeaderPhoneRinging() {
    // Sende ein Event, um das Telefonklingeln im Header zu stoppen
    const headerPhone = document.querySelector('.phone-icon-container .la-phone');
    if (headerPhone) {
      headerPhone.classList.remove('ringing');
      // Entferne auch die konzentrischen Kreise
      const ripple = document.querySelector('.phone-ripple');
      if (ripple) {
        ripple.remove();
      }
    }
  }
} 